export enum ButtonVolumeEvent{
    STATE_CHANGED = 'onStateChanged'
}
export enum ButtonVolumeState{
    ON = 'on',
    OFF = 'off'
}